import React, {useState} from 'react';
import {Button, Card, CardBody, CardHeader, Col, Modal, Row} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import ResourceItem from "../Lists/ResourceItem";
import {resource_strings} from "../../translations/resource_translations";
import resourceApiService from "../../api/resource-api-service";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const StripeSetupView = (props) => {
    const [visible, setVisible] = useState(true);
    const [showMore, setshowMore] = useState(false);
    const [ticketTypes, setTicketTypes] = useState(props.ticketTypes);
    const [redrawId, setRedrawId] = useState(0);

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    function toggleModal() {
        setVisible(false)
    };

    function connectStripeAccount() {
        if (props.sId && props.sId.length > 5) {
            props.disconnectStripe()
        } else {
            props.goToStripe()
        }
    };

    function showMoreText(e) {
        localize();
        setshowMore(true)
    }

    localize();

    function calcStripeFee(tt) {
        // const price = tt.price || 0;
        // const fee = (price * 0.01).toFixed(2);
        // return resourceStrings.public_profile.stripe_fee + ": ~" + currency + fee
        return ""
    }

    function togglePublic(tt) {
        const tts = ticketTypes
        resourceApiService.toggleTicketTypePublic(tt)

        tts.forEach(ticketType => {
            if (ticketType.id === tt.id) {
                ticketType.whitelisted = !ticketType.whitelisted
            }
        })
        setTicketTypes(tts)
        setRedrawId(redrawId + 1)
    }

    function resolveItemExtra(tt) {
        return tt.whitelisted ? resourceStrings.public : resourceStrings.hidden
    }

    function renderTicketTypes() {
        return <>
            {ticketTypes.map((tt) => (
                <ResourceItem
                    redrawId={redrawId}
                    key={tt.id.toString()}
                    item_name={tt.name}
                    icon={require("assets/img/icons/common/ticket_white.svg").default}
                    item_extra={resolveItemExtra(tt)}
                    additionaInfo={calcStripeFee(tt)}
                    onSelected={e => togglePublic(tt)}
                />
            ))}
        </>
    }

    return (
        <>
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={visible}
                toggle={props.toggle}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow">
                        <CardHeader className="bg-white border-0">
                            <Row className="align-items-center">
                                <Col xs="8">
                                    <h3 className="mb-0">{resourceStrings.public_profile.online_payments}</h3>
                                </Col>
                                <div className="col text-right">
                                    <Button
                                        color="warning"
                                        className="btn-facebook"
                                        onClick={e => connectStripeAccount(e)}
                                        size="lg"
                                    >
                                        {(props.sId && props.sId.length > 5) ? resourceStrings.public_profile.disconnect_stripe : resourceStrings.public_profile.connect_stripe}
                                    </Button>

                                </div>
                            </Row>
                        </CardHeader>
                        <CardBody>

                            <div style={{fontWeight: 600}}>
                                {resourceStrings.public_profile.stripe_expl_intro}
                            </div>

                            <a href={"https://stripe.com/en-es/pricing?locale=ru"} target="_blank">
                                {resourceStrings.public_profile.stripe_expl_intro_2}
                            </a>

                            {showMore &&
                                <div className="mt-3 mb-3">
                                    {resourceStrings.public_profile.stripe_expl_more}
                                </div>
                            }

                            {!showMore &&
                                <div className="col text-right mb-3">
                                    <Button
                                        color="secondary"

                                        onClick={e => showMoreText(e)}
                                        size="sm"
                                    >
                                        {commonStrings.read_more}
                                    </Button>
                                </div>
                            }

                            {renderTicketTypes()}

                            <div style={{marginTop: 10, display: "flex", justifyContent: "end"}}>
                                <Button
                                    color="warning"
                                    outline="button"
                                    size="lg"
                                    onClick={props.toggle}
                                >
                                    {commonStrings.close}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        </>
    );
};

export default StripeSetupView;